"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var METHODS = {
  OPEN: ['requestFullscreen', 'webkitRequestFullscreen', 'webkitRequestFullScreen', 'mozRequestFullScreen', 'msRequestFullscreen'],
  CLOSE: ['exitFullscreen', 'webkitExitFullscreen', 'msExitFullscreen', 'webkitCancelFullScreen', 'mozCancelFullScreen'],
  ACTIVE_ELEMENT: ['fullscreenElement', 'webkitFullscreenElement', 'webkitCurrentFullScreenElement', 'mozFullScreenElement', 'msFullscreenElement'],
  SUPPORTED: ['webkitFullscreenEnabled', 'webkitCancelFullScreen', 'mozFullScreenEnabled', 'msFullscreenEnabled'],
  LISTENERS: ['fullscreenchange', 'webkitfullscreenchange', 'webkitfullscreenchange', 'mozfullscreenchange', 'MSFullscreenChange']
};
var Fullscreen = /** @class */function () {
  function Fullscreen() {}
  Fullscreen.prototype.open = function (element) {
    if (element) {
      for (var _i = 0, _a = METHODS.OPEN; _i < _a.length; _i++) {
        var callbackName = _a[_i];
        //@ts-ignore
        if (element[callbackName]) {
          //@ts-ignore
          element[callbackName]();
          break;
        }
      }
    }
  };
  Fullscreen.prototype.close = function () {
    var _doc = window.document;
    if (this.isFullscreen()) {
      for (var _i = 0, _a = METHODS.CLOSE; _i < _a.length; _i++) {
        var callbackName = _a[_i];
        //@ts-ignore
        if (_doc[callbackName]) {
          //@ts-ignore
          _doc[callbackName]();
          break;
        }
      }
    }
  };
  Fullscreen.prototype.isFullscreen = function () {
    var _doc = window.document;
    for (var _i = 0, _a = METHODS.ACTIVE_ELEMENT; _i < _a.length; _i++) {
      var callbackName = _a[_i];
      //@ts-ignore
      if (_doc[callbackName]) {
        //@ts-ignore
        return _doc[callbackName];
      }
    }
  };
  Fullscreen.prototype.isSupported = function () {
    var _a;
    var isSupported = false;
    var _doc = window.document;
    for (var _i = 0, _b = METHODS.SUPPORTED; _i < _b.length; _i++) {
      var callbackName = _b[_i];
      //@ts-ignore
      if (_doc[callbackName]) {
        //@ts-ignore
        isSupported = typeof _doc[callbackName] === 'boolean' ? _doc[callbackName] : (_a = _doc[callbackName]) === null || _a === void 0 ? void 0 : _a.call(_doc);
        break;
      }
    }
    return isSupported;
  };
  Fullscreen.prototype.addListener = function (callback) {
    for (var _i = 0, _a = METHODS.LISTENERS; _i < _a.length; _i++) {
      var callbackName = _a[_i];
      window.addEventListener(callbackName, callback);
    }
  };
  Fullscreen.prototype.removeListener = function (callback) {
    for (var _i = 0, _a = METHODS.LISTENERS; _i < _a.length; _i++) {
      var callbackName = _a[_i];
      window.removeEventListener(callbackName, callback);
    }
  };
  return Fullscreen;
}();
var _default = Fullscreen;
exports.default = _default;